<template>
    <div>
        <div class="card card-default w-100">
            <div class="card-body">
                <h4>UDN Lookup</h4>

                <div class="input-group">
                    <input v-model="udn" v-on:keyup.enter="goUdn" 
                           type="text" placeholder="UDN" aria-label="UDN" aria-describedby="button-go-udn" 
                           :class="['form-control', udn.length > 0 ? (validUdn ? 'is-valid' : 'is-invalid') : '' ]" 
                           style="min-width: 200px;">
                    <div class="input-group-append ml-auto">
                        <button class="btn btn-outline-secondary btn-sm" @click="useCamera = !useCamera">{{ useCamera ? 'Close' : 'Open' }} Camera </button>
                        <button @click="goUdn" class="btn btn-success btn-sm px-4" id="button-go-udn" :disabled="!validUdn">Go</button>
                    </div>
                </div>

                <div class="alert alert-info mt-2" v-if="loadingCamera">Accessing Camera...</div>
                <div class="alert alert-danger mt-2" role="alert" v-if="cameraError" ><strong>Error:</strong> {{ cameraError }}</div>
                <qrcode-stream v-if="useCamera" @decode="onDecode" @init="onInit" class="mt-2"></qrcode-stream>
            </div>


        </div>
    </div>

</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'


    export default {
        components: {
            QrcodeStream,
        },
        data() {
            return {
                udn: '',
                validUdn: false,
                useCamera: false,
                cameraError: '',
                loadingCamera: false
            }
        },
        methods: {
            goUdn() {
                if (this.validUdn) {
                    this.$router.push({ path: `/udn/${this.udn}` });
                }
            },
            onDecode(decodedString) {
              
                var splitString = decodedString.split('/');
                var lastPart = splitString[splitString.length - 1];

                if (!(/^[0-9A-F]{8}$/i.test(lastPart)) || lastPart.length != 8) {
                    this.$notify({
                        type: "alert-warning",
                        text: `Unknown udn '${ lastPart }' found in QR code: ${ decodedString }`
                    });
                    return;
                }

                this.$notify({
                        type: "alert-success",
                        text: `Found udn ${ decodedString }`
                    });

                this.$router.push({ path: `/udn/${lastPart}` });

            },
            async onInit(promise) {
                this.loadingCamera = true;
                try {
                    await promise
                    // successfully initialized
                }
                catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.cameraError = 'User denied camera access permisson';
                    } else if (error.name === 'NotFoundError') {
                        this.cameraError = 'No suitable camera device installed';
                    } else if (error.name === 'NotSupportedError') {
                        this.cameraError = 'Page is not served over HTTPS (or localhost)';
                    } else if (error.name === 'NotReadableError') {
                        this.cameraError = 'Maybe camera is already in use';
                    } else if (error.name === 'OverconstrainedError') {
                        this.cameraError = 'Did you requested the front camera although there is none?';
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.cameraError = 'Browser seems to be lacking features';
                    }
                    this.useCamera = false;
                }
                finally {
                    this.loadingCamera = false;
                }
            }
        },
        watch: {
            udn(udn) {

                var qrCodeFormat = "http://sk4.info/udn/";
                var replaced = udn.replace(qrCodeFormat, '');

                if (replaced != udn)
                    this.udn = replaced;

                this.validUdn = /^[0-9A-Fa-f]{8}$/.test(udn);
            }
        }
    }
</script>

<style>
</style>
